<template>
  <div class="lpPagination">
    <div class="total">
      共{{ total }}条
    </div>
    <!-- <div class="jump">
      <span>跳转到</span>
      <el-select v-model="current" @change="onChangePage" placeholder="">
        <el-option
          v-for="item in pageArray"
          :key="item"
          :label="item"
          :value="item">
        </el-option>
      </el-select>
      <span>页</span>
    </div> -->
    <el-pagination
      background
      layout="prev, pager, next"
      :total="total"
      :current-page="current"
      :pageSize="pageSize"
      @current-change="onChangePage"
      >
    </el-pagination>
  </div>
</template>
<script>
export default {
    name: 'lpPagination',
    props: {
        total:{//总条数
          type:Number,
          default:0
        },
        current:{//当前页数
          type:Number,
          default:1
        },
        pageSize:{//每页条数
          type:Number,
          default:10
        }
    },
    data () {
      return {
        pageArray:[]
      }
    },
    created() {
      
    },
    methods: {
        //修改页码
        onChangePage(page){
          this.$emit('current-change',page)
        }
    },
    watch: {
      total:function(newVal,oldVal){
        const { pageSize,total }=this;
        this.pageArray=new Array(Math.ceil(total/pageSize)).fill(1).map((v,k)=>k+1)
      }
    },
};
</script>
<style scoped lang="less">
  .lpPagination{
    font-family: MicrosoftYaHei;
    color: #666666;
    font-size: 12px;
    margin: 24px 24px;
    text-align: right;
    .total{
      display: inline-block;
      height: 32px;
      line-height: 32px;
      vertical-align: middle;
      letter-spacing:3px;
    }
    .jump{
      display: inline-block;
      vertical-align: middle;
      span{
        display: inline-block;
        vertical-align: middle;
        height: 32px;
        line-height: 32px;
      }
      .el-select{
        display: inline-block;
        vertical-align: middle;
        width: 60px;
        height: 28px;
        /deep/ .el-input__inner{
          height: 28px;
          line-height: 28px;
        }
        /deep/ .el-input__icon{
          line-height: 28px;
        }
      }
    }
    .el-pagination{
      display: inline-block;
      vertical-align: middle;
    }
    /deep/ .el-pager{
      li{
        width: 28px;
        min-width: auto;
        margin: 0px;
        padding: 0px;
        background: #FFFFFF;
        border: 1px solid #E1E3E4;
        border-right: none;
      }
      li:last-child{
        border-right: 1px solid #E1E3E4;
      }
      li.active{
        border: 1px solid #1890FF;
        background: #1890FF;
      }
    }
    /deep/ .el-pagination{
      .btn-prev,.btn-next{
        background: #FFFFFF;
        border: 1px solid #E1E3E4;
      }
        .el-pager li {
            margin: 0px 2px;
        }
    }
   
  }
</style>


// WEBPACK FOOTER //
// src/components/pagination/index.vue